import React, { ButtonHTMLAttributes, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LuClock3 } from 'react-icons/lu'
import { Box, Text } from '@chakra-ui/react'

import { DateTimePickerContext } from '../../helpers'
import { VisibleSectionEnum } from '../../interfaces'

import { DateTimePickerButton, DateTimePickerButtonContent } from './styles'

export const TimeButton = ({ ...buttonProps }: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => {
  const { dateTimeState, setDateTimeState } = useContext(DateTimePickerContext)
  const { t } = useTranslation(['common'])

  const {
    visibleSection,
    value: { time, day },
    props: { shouldDisableTimeButton },
    isLoading,
  } = dateTimeState

  const showTimeSection = () => {
    setDateTimeState((state) => ({ ...state, visibleSection: VisibleSectionEnum.TIME, isExpanded: true }))
  }

  const stylingProps = {
    isFocused: visibleSection === VisibleSectionEnum.TIME,
    isDisabled:
      day === undefined || isLoading || (shouldDisableTimeButton ? shouldDisableTimeButton(dateTimeState) : false),
  }

  return (
    <DateTimePickerButton onClick={showTimeSection} {...stylingProps} {...buttonProps}>
      <Box marginRight="14px" flexGrow={0} color="green.a200">
        <LuClock3 size={20} />
      </Box>
      <DateTimePickerButtonContent marginRight="auto">
        <Text color="green.a200" fontWeight={700} fontSize="xxs">
          {t('time')}
        </Text>
        {typeof time !== 'string' ? (
          <Text fontSize="sm" color="gray.400">
            {t('selectHour')}
          </Text>
        ) : (
          <Text fontSize="sm">{time}:00</Text>
        )}
      </DateTimePickerButtonContent>
    </DateTimePickerButton>
  )
}
